import React, { useState, useEffect, useRef } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
import "./index.css";
import { fetchTherapistBookings } from "../../actions/dataLoad";
import { useLocation, Link, useHistory } from "react-router-dom";
import { cancelSlot, rescheduleSlot } from "../../actions/bookSlot";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { useUserInfoSelector, useUserTokenSelector } from "store/reducers";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "store/actions";

const baseMonthOptions = [
  { value: 1, label: "January", short: "Jan" },
  { value: 2, label: "February", short: "Feb" },
  { value: 3, label: "March", short: "Mar" },
  { value: 4, label: "April", short: "Apr" },
  { value: 5, label: "May", short: "May" },
  { value: 6, label: "June", short: "Jun" },
  { value: 7, label: "July", short: "Jul" },
  { value: 8, label: "August", short: "Aug" },
  { value: 9, label: "September", short: "Sep" },
  { value: 10, label: "October", short: "Oct" },
  { value: 11, label: "November", short: "Nov" },
  { value: 12, label: "December", short: "Dec" },
];

const avatar = {
  female: "https://ucarecdn.com/c22b8f55-8c68-411e-a5c9-8b5b99c08701/femaleEmoji.svg",
  male: "https://ucarecdn.com/52c99efd-cba4-4fe1-93f2-e393088b7a0c/male.svg",
  other: "https://ucarecdn.com/c7bb4c01-2258-428d-b8ce-e2196ee63220/lgbtq.svg",
};

const allMonthsOption = { value: "all", label: "All Months", short: "All" };
const allYearsOption = { label: "All times", value: "all" };

export const TherapistSessions = () => {
  const [cancelPopup, setCancelPopup] = useState(false);
  const [reschedulePopup, setReschedulePopup] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [currentDateSavings, setCurrentDateSavings] = useState(new Date());
  const [upcomingSelectedMonth, setUpcomingSelectedMonth] = useState(
    new Date().getMonth() + 1
  );
  const [upcomingSelectedYear, setUpcomingSelectedYear] = useState(
    new Date().getFullYear().toString()
  );
  const [completedSelectedMonth, setCompletedSelectedMonth] = useState(
    new Date().getMonth() + 1
  );
  const [completedSelectedYear, setCompletedSelectedYear] = useState(
    new Date().getFullYear().toString()
  );
  const userToken = useUserTokenSelector();
  const [bookingId, setBookingId] = useState("");
  const [showOverlay, setShowOverlay] = useState(false);
  const [elementId, setElementId] = useState("");
  const [firstBookingId, setFirstBookingId] = useState("");
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const [upcomingBookings, setUpcomingBookings] = useState([]);
  const dispatch = useDispatch();
  const [completedBookings, setCompletedBookings] = useState([]);
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState("upcoming");
  const topBtnsRef = useRef(null);
  const [isTopBtnsVisible, setIsTopBtnsVisible] = useState(true);
  const {idTherapist: therapistId} = useUserInfoSelector();

  const history = useHistory();

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1; // 1-12

  // Calculate years array (similar to UserBookings)
  // For TherapistSessions, we don't have a direct 'therapistFirstBookingYear'.
  // We'll use a default range, e.g., current year and previous 2 years.
  // You can adjust 'earliestYearForTherapist' if you fetch this data.
  const earliestYearForTherapist = currentYear - 2;
  const completedYearsArray = [
    allYearsOption,
    ...Array.from({ length: currentYear - earliestYearForTherapist + 1 }, (_, i) => ({
      label: (earliestYearForTherapist + i).toString(),
      value: (earliestYearForTherapist + i).toString(),
    })),
  ];

  const upcomingYearsArray = [
    allYearsOption,
    { label: currentYear.toString(), value: currentYear.toString() },
  ];
  if (currentMonth === 12) {
    upcomingYearsArray.push({ label: (currentYear + 1).toString(), value: (currentYear + 1).toString() });
  }

  const nextMonthValue = currentMonth === 12 ? 1 : currentMonth + 1;
  const currentMonthOption = baseMonthOptions.find(m => m.value === currentMonth);
  const nextMonthOption = baseMonthOptions.find(m => m.value === nextMonthValue);
  const januaryOption = baseMonthOptions.find(m => m.value === 1);

  const getFilteredMonthsUpcoming = (selectedYr) => {
    if (selectedYr === currentYear.toString()) {
      return [allMonthsOption, currentMonthOption, nextMonthOption].filter(Boolean);
    } else if (selectedYr === (currentYear + 1).toString() && currentMonth === 12) {
      return [allMonthsOption, januaryOption].filter(Boolean);
    }
    // Default for "all" year or any other case (though upcomingSelectedYear should be limited)
    return [allMonthsOption];
  };

  const getFilteredMonthsCompleted = (selectedYr) => {
    if (selectedYr === currentYear.toString() || selectedYr === "all") {
      return [
        allMonthsOption,
        ...baseMonthOptions.filter(m => m.value <= currentMonth)
      ].filter(Boolean);
    } else if (selectedYr !== "all" && parseInt(selectedYr) < currentYear) { // Past year
      return [allMonthsOption, ...baseMonthOptions];
    }
    return [allMonthsOption, ...baseMonthOptions]; // Default for "all" or future year (if applicable)
  };

  const handleMonthChange = (type, value) => {
    const monthValue = value === "all" ? "all" : parseInt(value);
    if (type === "upcoming") {
      setUpcomingSelectedMonth(monthValue);
      if (monthValue !== "all" && upcomingSelectedYear === "all") {
        setUpcomingSelectedYear(currentYear.toString());
      }
    } else {
      setCompletedSelectedMonth(monthValue);
      if (monthValue !== "all" && completedSelectedYear === "all") {
        setCompletedSelectedYear(currentYear.toString());
      }
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsTopBtnsVisible(entry.isIntersecting);
      },
      { root: null, threshold: 0.1 }
    );

    if (topBtnsRef.current) {
      observer.observe(topBtnsRef.current);
    }

    return () => {
      if (topBtnsRef.current) observer.unobserve(topBtnsRef.current);
    };
  }, []);

  useEffect(() => {
    loadUpcomingSessions(upcomingSelectedMonth, upcomingSelectedYear);
    loadCompletedSessions(completedSelectedMonth, completedSelectedYear);
  }, []);

  const showError = (text) => {
    setError(text);
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      setOpen(false);
    }
    setOpen(false);
  };

  useEffect(() => {
    let today = new Date();
    setCurrentDateSavings(today);
    setCurrentDate(today); // This state seems unused for filtering, but kept for now
    setUpcomingSelectedMonth(currentMonth); // Initialize with current month number
    setUpcomingSelectedYear(currentYear.toString()); // Initialize with current year string
    setCompletedSelectedMonth(currentMonth); // Initialize with current month number
    setCompletedSelectedYear(currentYear.toString()); // Initialize with current year string
    (async () => {
      dispatch(startLoading());
      await allSessions({ monthNumber: today.getMonth() + 1 , year: today.getFullYear()});
      dispatch(stopLoading());
    })();
  }, []);

  const cancelBookingSlot = async () => {
    if (bookingId) {
      let bookingID = bookingId;
      try {
        dispatch(startLoading());
        const data = {
          bookingID,
        };
        const res = await cancelSlot(data, userToken);
        if (res.data.isCancel) {
          setCancelPopup(false);
          await allSessions({monthNumber: upcomingSelectedMonth, year: upcomingSelectedYear});
        } else {
          setCancelPopup(false);
          showError(res.data.error);
        }
        setBookingId("");
        // setmeetId("");
        dispatch(stopLoading());
      } catch (err) {
        console.log(err);
        dispatch(stopLoading());
        setBookingId("");
        // setmeetId("");
        setCancelPopup(false);
        if (err.response.data.redirectToSignIn) {
          showError(err.response.data.error);
          setTimeout(
            () =>
              history.push({
                pathname: "/signin",
                state: { referer: location.pathname },
              }),
            3000
          );
        } else {
          showError(err.response.data.error);
        }
      }
    }
  };
  const handleReschedule = async () => {
    history.push({
      pathname: '/dashboard/therapist/rescheduleSession',
      state: {
        bookingID: bookingId,
        therapistID: therapistId,
        isTherapist: true,
      }
    })
    setReschedulePopup(false); // Close the confirmation popup
    setBookingId(""); 
  }

  const allSessions = async ({ monthNumber, year }) => {
    try {
      const res = await fetchTherapistBookings(
        {type: "all",timeOffset: new Date().getTimezoneOffset(),month:monthNumber, year: year
        },
        userToken
      );
      const upcomingBookingsData = res.data["upcoming"];
      const completedBookingsData = res.data["completed"];

      // Apply business logic like recommendation flag
      let i = 0;
      for (const booking of completedBookingsData.data) {
        booking.showRecommendation = !booking.isCancel && i < 2;
        if (!booking.isCancel && i < 2) i++;
      }

      setUpcomingBookings(upcomingBookingsData.data);
      setCompletedBookings(completedBookingsData.data);
      setFirstBookingId(res.data.firstBookingId);
    } catch (err) {
      showError(err?.response?.data?.error);
    }
  };

  const getMonthName = (i) => {
    const monthObj = baseMonthOptions.find(m => m.value === i + 1);
    return monthObj ? monthObj.short : 'N/A';
  };

  const handleUpcomingMonthSelect = async (monthNumber) => {
    const newMonth = monthNumber === "all" ? "all" : parseInt(monthNumber);
    setUpcomingSelectedMonth(newMonth);
    let yearToUse = upcomingSelectedYear;
    if (newMonth !== "all" && upcomingSelectedYear === "all") {
      yearToUse = currentYear.toString();
      setUpcomingSelectedYear(yearToUse);
    }
    await loadUpcomingSessions(newMonth, yearToUse);
  };

  const handleUpcomingYearSelect = async (year) => {
    setUpcomingSelectedYear(year);
    let monthToUse = upcomingSelectedMonth;
    if (year === "all") {
      monthToUse = "all";
      setUpcomingSelectedMonth("all");
    } else if (year === (currentYear + 1).toString() && currentMonth === 12) {
      monthToUse = upcomingSelectedMonth === 1 ? 1 : "all"; // If Jan is already selected, keep it, else "all"
      if (monthToUse === "all") setUpcomingSelectedMonth("all");
    } else if (year === currentYear.toString()) {
      // Keep current month if valid, else "all"
      if (upcomingSelectedMonth !== currentMonth && upcomingSelectedMonth !== nextMonthValue && upcomingSelectedMonth !== "all") {
        monthToUse = "all";
        setUpcomingSelectedMonth("all");
      }
    }
    await loadUpcomingSessions(monthToUse, year);
  };

  const handleCompletedMonthSelect = async (monthNumber) => {
    const newMonth = monthNumber === "all" ? "all" : parseInt(monthNumber);
    setCompletedSelectedMonth(newMonth);
    let yearToUse = completedSelectedYear;
    if (newMonth !== "all" && completedSelectedYear === "all") {
      yearToUse = currentYear.toString();
      setCompletedSelectedYear(yearToUse);
    }
    await loadCompletedSessions(newMonth, yearToUse);
  };

  const handleCompletedYearSelect = async (year) => {
    setCompletedSelectedYear(year);
    let monthToPass = completedSelectedMonth;
    if (year === "all") {
      monthToPass = "all";
      setCompletedSelectedMonth("all");
    }

    await loadCompletedSessions(completedSelectedMonth, year);
  };

  const loadUpcomingSessions = async (monthNumber, year) => {
    dispatch(startLoading());
    await allSessions({ monthNumber, year });
    dispatch(stopLoading());
  };

  const loadCompletedSessions = async (monthNumber, year) => {
    dispatch(startLoading());
    await allSessions({ monthNumber, year });
    dispatch(stopLoading());
  };

  return (
    <div className="sessions-screen-container">
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
          {error}
        </Alert>
      </Snackbar>
      <div className="top-btns-row" ref={topBtnsRef}>
        <div
          onClick={() => setSelectedTab("upcoming")}
          className={`upcoming-sessions-Btn ${
            selectedTab === "upcoming" ? "green" : ""
          }`}
        >
          <p
            className={`upcoming-sessions-Btn-txt ${
              selectedTab === "upcoming" ? "greenTxt" : ""
            }`}
          >
            Upcoming Sessions
          </p>
        </div>
        <div
          onClick={() => setSelectedTab("completed")}
          className={`Completed-sessions-Btn ${
            selectedTab === "completed" ? "green" : ""
          }`}
        >
          <p
            className={`Completed-sessions-Btn-txt ${
              selectedTab === "completed" ? "greenTxt" : ""
            }`}
          >
            Completed Sessions
          </p>
        </div>
      </div>
      <div className="upcoming-sessions-cont">
        <div className="therapist-sessions-header">
          <p className="upcoming-card-title">Upcoming sessions</p>
          <div className="tb-client-filter prof">
            <select
              value={upcomingSelectedMonth === "all" ? "all" : upcomingSelectedMonth.toString()}
              onChange={(e) => {
                handleUpcomingMonthSelect(e.target.value);
              }}
            >
              {getFilteredMonthsUpcoming(upcomingSelectedYear).map((month) => (
                <option key={month.value} value={month.value}>
                  {month.label}
                </option>
              ))}
            </select>
            <select
              value={upcomingSelectedYear.toString()}
              onChange={(e) =>
                handleUpcomingYearSelect(e.target.value)
              }
            >
              {upcomingYearsArray.map((year) => (
                <option key={year.value} value={year.value}>
                  {year.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        {upcomingBookings.length > 0 && (
          <div className="upcoming-sessions-header">
            <p style={{ flex: "1" }}></p>
            <p style={{ flex: "2.7",textAlign:'left' }}>Name</p>
            <p style={{ flex: "2.2" }}>Symptoms</p>
            <p style={{ flex: "2.2" }}>Upcoming session<br />date & time</p>
            <p style={{ flex: "2.5" }}></p>
          </div>
        )}
        <div className="upcoming-sessions-cont-div">
          {(selectedTab === "upcoming" || !isTopBtnsVisible) &&
            (upcomingBookings.length > 0 ? (
              upcomingBookings.map((booking, i) => {
                const {
                  userName,
                  isCancel,
                  sessionTime,
                  _id,
                  link,
                  problemCategories,
                  sessionDate,
                  avatar_url,
                  gender,
                  userAge
                } = booking;
                let { start, end } = sessionTime;
                let timeDifference =
                  new Date(start).getTime() - new Date().getTime();
                let timeDifferenceEnd =
                  new Date(end).getTime() - new Date().getTime();
                let date = new Date(start).getDate();
                let month = new Date(start).getMonth();
                start = new Date(start).toLocaleTimeString();
                start = start.replace(":00", "");
                end = new Date(end).toLocaleTimeString();
                end = end.replace(":00", "");

                let showJoinButton =
                  !isCancel &&
                  timeDifference <= 900000 &&
                  timeDifferenceEnd >= 0;
                let canBeCancelled = timeDifference > 3600000 * 6;

                return (
                  <div key={_id} className="upcoming-sessions-row">
                    <div className="sessions-name-img-msg-row" style={{flex: '4.3'}}>
                      <div
                        className="profile-photo-bg"
                        onClick={() =>
                          history.push(`/dashboard/therapist/chats/${booking.userID}`)
                        }
                      >
                        <img
                          src={avatar_url ? avatar_url : gender ? avatar[gender] : "https://ucarecdn.com/c7bb4c01-2258-428d-b8ce-e2196ee63220/lgbtq.svg"}
                          alt="Profile Pic"
                        />
                      </div>
                      <div className="upcoming-sessions-client-name" onClick={() =>
                          history.push(`/dashboard/therapist/chats/${booking.userID}`)
                        }>
                        <p className="upcoming-sessions-userName">{userName}</p>
                        <p className="upcoming-sessions-age">Age: {userAge} yrs</p>
                      </div>
                      <div
                        className="upcoming-sessions-chatIcon"
                        onClick={() =>
                          history.push(`/dashboard/therapist/chats/${booking.userID}`)
                        }
                      >
                        <img
                          src="https://ucarecdn.com/83c14859-a37e-4a28-9665-f3b2e819b5be/chatIcon.svg"
                          alt="msg"
                        />
                      </div>
                      <div
                        className="upcoming-sessions-videoCameraIcon"
                        onClick={() => {
                              if (showJoinButton) {
                                if (link.startsWith("http")) {
                                  window.location.href = link; // external link
                                } else {
                                  history.push(link); // internal route
                                }
                              }
                            }}
                            style={{
                              cursor: showJoinButton ? "pointer" : "not-allowed",
                              backgroundColor: showJoinButton ? "" : "#ccc",
                            }}
                      >
                        <img
                          src="https://ucarecdn.com/3044bc08-e0b9-413c-b01e-2d508f35a480/videoCameraIcon.svg"
                          alt="videoCameraIcon"
                        />
                      </div>
                    </div>
                    <div className="upcoming-sessions-symptomsData">
                      <p className="upcoming-sessions-symptomsTxt">Symptoms:</p>
                      <p className="upcoming-sessions-symptoms">
                        {problemCategories.join(", ")}
                      </p>
                    </div>
                    <p className="upcoming-sessions-dateTime">
                      {date} {getMonthName(month)}, {start}-{end}
                    </p>
                    {
                      showJoinButton ? 
                      <div
                          className="upcoming-sessions-videoCameraIcon"
                          onClick={() => {
                            if (showJoinButton) {
                              if (link.startsWith("http")) {
                                window.location.href = link; // external link
                              } else {
                                history.push(link); // internal route
                              }
                            }
                          }}
                          style={{
                            cursor: showJoinButton ? "pointer" : "not-allowed",
                            backgroundColor: showJoinButton ? "" : "#ccc",
                          }}
                        >
                      <img
                        src="https://ucarecdn.com/3044bc08-e0b9-413c-b01e-2d508f35a480/videoCameraIcon.svg"
                        alt="videoCameraIcon"
                        style={{ opacity: showJoinButton ? 1 : 0.5 }}
                      />
                    </div>

                    :

                                        <div className="btns-row">
                          <>
                            <div className="upcoming-sessions-cancelBtn">
                              <p
                                onClick={() => {
                                  setCancelPopup(true);
                                  setBookingId(_id);
                                }}
                              >
                                Cancel
                              </p>
                            </div>
                            <div className="upcoming-sessions-RescheduleBtn" onClick={() => {
                              setReschedulePopup(true);
                              setBookingId(_id);
                            }}>
                              <p>Reschedule</p>
                            </div>
                          </>
                    </div>
                    }
                  </div>
                );
              })
            ) : (
              <div className="noSessionBlissDiv">
                <img
                  src="https://ucarecdn.com/0331d13b-e7fd-4ea2-9b20-3a5fb73b1df4/noUpcomingSessionBliss.svg"
                  alt="No upcoming sessions"
                  className="noSessionBliss"
                />
              </div>
            ))}
        </div>
      </div>
      <div className="completed-sessions-cont">
        <div className="therapist-sessions-header">
          <p className="upcoming-card-title">Completed sessions</p>
          <div className="tb-client-filter prof">
            <select
              value={completedSelectedMonth === "all" ? "all" : completedSelectedMonth.toString()}
              onChange={(e) => {
                handleCompletedMonthSelect(e.target.value)
              }}
            >
              {getFilteredMonthsCompleted(completedSelectedYear).map((month) => (
                <option key={month.value} value={month.value}>
                  {month.label}
                </option>
              ))}
            </select>
            <select
              value={completedSelectedYear === "all" ? "all" : completedSelectedYear.toString()}
              onChange={(e) =>
                handleCompletedYearSelect(e.target.value)
              }
            >
              {completedYearsArray.map((year) => (
                <option key={year.value} value={year.value}>
                  {year.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        {completedBookings.length > 0 && (
          <div className="upcoming-sessions-header">
            <p style={{ flex: "1" }}></p>
            <p style={{ flex: "2.7",textAlign:'left' }}>Name</p>
            <p style={{ flex: "2.2", }}>Symptoms</p>
            <p style={{ flex: "2.2", }}>Last session<br/>date & time</p>
            <p style={{ flex: "2.5" }}></p>
          </div>
        )}
        <div className="completed-sessions-cont-div">
          {(selectedTab === "completed" || !isTopBtnsVisible) &&
            (completedBookings.length > 0 ? (
              completedBookings.map((booking, i) => {
                const {
                  sessionTime,
                  _id,
                  isCancel,
                  userName,
                  problemCategories,
                  Rating: StarRating,
                  CaseNotes = "",
                  Tasks = [],
                  userID,
                  userAge,
                  avatar_url,
                  gender
                } = booking;
                let { start, end } = sessionTime;
                let timeDifference =
                  new Date(start).getTime() - new Date().getTime();
                let date = new Date(start).getDate();
                let month = new Date(start).getMonth();
                start = new Date(start).toLocaleTimeString();
                start = start.replace(":00", "");
                end = new Date(end).toLocaleTimeString();
                end = end.replace(":00", "");
                const { showRecommendation } = booking;

                return (
                  <div
                    className="completed-sessions-row"
                    key={_id}
                    style={{
                      borderBottom:
                        i === completedBookings.length - 1 ? "0px" : "",
                    }}
                  >
                    <div className="sessions-name-img-msg-row" style={{flex: '5.1'}}>
                      <div
                        className="profile-photo-bg"
                        onClick={() =>
                          history.push(`/dashboard/therapist/clients/${booking.userID}`)
                        }
                      >
                        <img
                          src={avatar_url ? avatar_url : gender  ? avatar[gender] : "https://ucarecdn.com/c7bb4c01-2258-428d-b8ce-e2196ee63220/lgbtq.svg"}
                          alt="Profile Pic"
                        />
                      </div>
                      <div className="completed-sessions-client-name ">
                        <p className="upcoming-sessions-userName">{userName}</p>
                        <p className="upcoming-sessions-age">Age: {userAge} yrs</p>
                      </div>
                      <div
                        className="upcoming-sessions-chatIcon"
                        onClick={() =>
                          history.push(`/dashboard/therapist/chats/${booking.userID}`)
                        }
                      >
                        <img
                          src="https://ucarecdn.com/83c14859-a37e-4a28-9665-f3b2e819b5be/chatIcon.svg"
                          alt="msg"
                        />
                      </div>
                    </div>
                    <div className="upcoming-sessions-symptomsData">
                      <p className="upcoming-sessions-symptomsTxt">Symptoms:</p>
                      <p className="upcoming-sessions-symptoms">
                        {problemCategories.join(", ")}
                      </p>
                    </div>
                    <p className="upcoming-sessions-dateTime">
                      {date} {getMonthName(month)}, {start}-{end}
                    </p>
                    <div className="btns-row">
                      {isCancel && <div
                        className="completed-sessions-cancelBtn"
                        style={{ marginRight: "10px" }}
                      >
                        <p>Cancelled</p>
                      </div>}
                      {!isCancel && <div
                        className="completed-sessions-TaskBtn"
                        onClick={() =>
                          history.push(`/dashboard/therapist/clients/${userID}?tab=tasks`)
                        }
                      >
                        <p>Add Tasks</p>
                        <img
                          src="https://ucarecdn.com/a4bcdeca-13db-4439-b77b-76801c792fac/addNotes.svg"
                          className="tasks-btn-Icon"
                        />
                      </div>}
                      {!isCancel && <div
                        className="completed-sessions-notesBtn"
                        onClick={() =>
                          history.push(`/dashboard/therapist/clients/${userID}?tab=casenotes`)
                        }
                      >
                        {/* <p>Submit Case Notes</p> */}
                        <p>View Case Notes</p>
                      </div>}
                    </div>
                  </div>
                );
              })
            ) : (
              // <p></p>
              <div className="noSessionBlissDiv">
                <img
                  src="https://ucarecdn.com/33fa1d96-b6c7-4830-aa86-19464bc77bdd/noCompletedSessionBliss.svg"
                  alt="No completed sessions"
                  className="noSessionBliss"
                />
              </div>
            ))}
        </div>
      </div>
      <Dialog
        open={cancelPopup || reschedulePopup}
        onClose={() => cancelPopup ? setCancelPopup(false) : setReschedulePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ zIndex: 999999999 }}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to ${cancelPopup ? 'cancel': 'reschedule'} this session?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => cancelPopup ?  setCancelPopup(false): setReschedulePopup(false)} color="primary">
            No
          </Button>
          <Button onClick={() => cancelPopup ? cancelBookingSlot(): handleReschedule()} color="primary">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      {showOverlay && (
        <div
          className="popup-payment-alert-overaly"
          style={{ backgroundColor: "transparent", zIndex: 9997 }}
          onClick={() => {
            const element = doucment.getElementById(elementId);
            document.getElementById(elementId).style.pointerEvents = "none";
            element.style.display = "none";
            element.style.pointerEvents = "none";
            setShowOverlay(false);
            setElementId(null);
            setShowOverlay(false);
            setElementId("");
          }}
        ></div>
      )}
    </div>
  );
};

export default TherapistSessions;
